import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { SITE } from "@/config/site";

export function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const navLinks = [
    { to: "/", label: t.nav.home },
    { to: "/about", label: t.nav.about },
    { to: "/mobility", label: t.nav.mobility },
    { to: "/services", label: t.nav.services },
    { to: "/contact", label: t.nav.contact },
  ];
  const innovationLinks = [
    { to: "/innovation", label: t.footer.mouyia },
    { to: "/applications", label: t.footer.applications },
    { to: "/applications/learnova", label: t.footer.learnova },
  ];

  return (
    <footer className="bg-ink text-sand" data-testid="site-footer">
      <div className="container-site py-14 sm:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src="/logo-512.png" alt="" className="h-12 w-12 shrink-0 object-contain" aria-hidden="true" />
            <span className="font-display font-extrabold tracking-tight text-lg">CONGO BOURSE</span>
          </div>
          <p className="mt-4 text-sm text-sand/70 max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <p className="mt-3 text-xs font-mono uppercase tracking-[0.18em] text-sand/50">{t.footer.relationship}</p>
        </div>

        <nav className="md:col-span-2" aria-label="Footer">
          <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-ochre">{t.footer.navTitle}</h2>
          <ul className="mt-4 space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-sand/75 hover:text-white transition-colors duration-200">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="md:col-span-3" aria-label="Innovation">
          <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-ochre">{t.footer.innovationTitle}</h2>
          <ul className="mt-4 space-y-2.5">
            {innovationLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-sand/75 hover:text-white transition-colors duration-200 inline-flex items-center gap-1">
                  {l.label}
                  <ArrowUpRight className="h-3.5 w-3.5 opacity-50" aria-hidden="true" />
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-2">
          <h2 className="text-xs font-mono uppercase tracking-[0.2em] text-ochre">{t.footer.contactTitle}</h2>
          <a
            href={`mailto:${SITE.contactEmail}`}
            data-testid="footer-email-link"
            className="mt-4 inline-flex items-center gap-2 text-sm text-sand/75 hover:text-white transition-colors duration-200 break-all"
          >
            <Mail className="h-4 w-4 shrink-0" aria-hidden="true" />
            {SITE.contactEmail}
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-sand/50">
            © {year} Congo Bourse. {t.footer.rights}
          </p>
          <p className="text-xs font-mono text-sand/40">www.congobourse.org</p>
        </div>
      </div>
    </footer>
  );
}
